import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { alpha, useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
import { TNO_BUSINESS_PATROCINIO_PATH } from '../brandAssets';

const PatrocinioCallout = () => {
  const theme = useTheme();
  const primary = theme.palette.primary.main;

  return (
    <Box mt={8} mb={2}>
      <Card
        elevation={0}
        sx={{
          borderRadius: 3,
          border: `1px solid ${alpha(primary, 0.2)}`,
          background: `linear-gradient(135deg, ${alpha(primary, 0.08)} 0%, ${alpha(primary, 0.02)} 100%)`,
        }}
      >
        <CardContent sx={{ p: { xs: 3, md: 4 }, textAlign: 'center' }}>
          <Box display="flex" justifyContent="center" mb={2}>
            <BusinessCenterIcon sx={{ fontSize: 40, color: primary }} />
          </Box>
          <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 700 }}>
            ¿Tu marca quiere patrocinar TNO Business?
          </Typography>
          <Typography
            variant="body1"
            color="textSecondary"
            sx={{ maxWidth: 640, mx: 'auto', mb: 3 }}
          >
            Consulta el media kit de patrocinio: opciones de comercialización, paquetes, métricas y
            propuesta genérica para marcas B2B en el ecosistema TNO Network.
          </Typography>
          <Button
            component={RouterLink}
            to={TNO_BUSINESS_PATROCINIO_PATH}
            variant="contained"
            color="primary"
            size="large"
          >
            Ver media kit de patrocinio
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default PatrocinioCallout;
